import { render } from "./NewPayment.vue?vue&type=template&id=7227cfe9"
import script from "./NewPayment.vue?vue&type=script&lang=js"
export * from "./NewPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__